import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ChatTeardropDotsIcon } from "@phosphor-icons/react";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

/**
 * Opens (or creates) a 1:1 DM thread with `sellerId` and routes the user
 * to /messages?thread_id=… Hidden when viewing your own profile.
 */
export default function MessageSellerButton({ sellerId, sellerName, size = "default" }) {
  const { user } = useAuth() || {};
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);

  if (!sellerId || (user && user.user_id === sellerId)) return null;

  const onClick = async () => {
    if (!user) {
      navigate(`/login?next=/seller/${sellerId}`);
      return;
    }
    if (busy) return;
    setBusy(true);
    try {
      const { data } = await api.post("/dm/threads", { user_id: sellerId });
      navigate(`/messages?thread_id=${data.id}`);
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  const sizeCls =
    size === "sm"
      ? "h-8 px-3 text-xs"
      : size === "lg"
      ? "h-11 px-5 text-sm"
      : "h-9 px-4 text-sm";

  return (
    <Button
      onClick={onClick}
      disabled={busy}
      variant="outline"
      className={`${sizeCls} gap-1.5 border-zinc-300 hover:border-[#1D78AB] hover:text-[#1D78AB] transition-colors`}
      data-testid={`message-seller-btn-${sellerId}`}
      aria-label={sellerName ? `Message @${sellerName}` : "Send message"}
    >
      <ChatTeardropDotsIcon size={14} />
      Message
    </Button>
  );
}
